import { render, staticRenderFns } from "./DownloadApp.vue?vue&type=template&id=99714388&scoped=true&"
var script = {}
import style0 from "./DownloadApp.vue?vue&type=style&index=0&id=99714388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99714388",
  null
  
)

export default component.exports